module.exports = "<div class=bodypart-image hm-tap=\"$ctrl.AppServices.HeroManager.setBodyPart($ctrl.options, false)\" ng-style=\"{'background-image':'url({{$ctrl.AppServices.DataManager.config.settings.assetsPath}}{{$ctrl.AppServices.HeroManager.bodyBasePath}}{{$ctrl.options.image}})'}\"></div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/bodypart-image/bodypart-image.html
 ** module id = 73
 ** module chunks = 0
 **/